import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogCustomer } from "@/shared/models/CatalogCustomer";
import { ColDef, ICellRendererParams } from "ag-grid-community";

type Props = {
	setSelectedRowData: (customer: CatalogCustomer) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "CustomerName",
			headerName: "Name",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as CatalogCustomer,
				edit: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "customersContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	const getMenuOptions = (data: CatalogCustomer) => {
		let options: MenuOptionType[] = [];

		options = options.concat([
			{
				name: "New Customer",
				key: "new_customer",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);

		if (data) {
			options = options.concat([
				{
					name: "Edit Customer",
					key: "edit_customer",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Customer",
					key: "delete_customer",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return { columnDefs, getMenuOptions };
};
